module.exports = __webpack_public_path__ + "img/available-location.c46ef713.svg";